import useBookmark from '../useBookmark';
import type {
  Course,
  Enum_Bookmark_Category,
  KnowledgeBase,
  Podcast,
} from '@edwin-group/people-graphql/generated/graphql';
import Button from '@/components/Button';

interface BookmarkButtonProps {
  relationId: string;
  metadata: KnowledgeBase | Course | Podcast | null;
  typeId?: string;
  category: Enum_Bookmark_Category;
  onRemoveFromBookmark?: () => void;
  variant?: 'icon' | 'outline';
  removeLabel?: string;
}

export default function BookmarkButton({
  relationId,
  metadata,
  typeId,
  category,
  onRemoveFromBookmark,
  variant = 'icon',
  removeLabel = 'Remove from bookmarks',
}: BookmarkButtonProps) {
  const { exist, handleClick } = useBookmark({ relationId });

  const fill = exist ? '#000' : 'none';

  const onClick = async (e?: React.MouseEvent) => {
    e?.preventDefault();
    await handleClick(metadata, typeId, category, onRemoveFromBookmark);
  };

  if (variant === 'outline') {
    return (
      <Button theme="outline" onClick={onClick} aria-label={removeLabel} className="self-start">
        {removeLabel}
      </Button>
    );
  }

  return (
    <button aria-label="Bookmark" className="cursor-pointer border-none bg-none p-0" onClick={onClick}>
      <svg width="18" height="18" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.77639 10.3741L0.5 12.0123V1.62136C0.5 1.32962 0.615893 1.04983 0.822182 0.843545C1.02847 0.637255 1.30826 0.521362 1.6 0.521362H6.4C6.69174 0.521362 6.97153 0.637255 7.17782 0.843545C7.38411 1.04983 7.5 1.32962 7.5 1.62136V12.0123L4.22361 10.3741L4 10.2623L3.77639 10.3741Z"
          fill={fill}
          stroke="black"
        />
      </svg>
    </button>
  );
}
